<template>
  <div class="key-features-wrap-area">
    <div class="container">
      <div class="section-title">
        <span class="sub-title text-uppercase">KEY FEATURES</span>
        <h2>{{ data?.title || 'Most Probably Included Best Features Ever' }}</h2>
      </div>

      <div class="row justify-content-center">
        <div
          class="col-xl-4 col-lg-6 col-sm-6 col-md-6"
          v-for="(feature, index) in data?.features"
          :key="feature?.title"
        >
          <div :class="index % 2 === 0 ? 'key-features-card style-three' : 'key-features-card style-three bg-color-three'" >
            <div class="icon">
              <i :class="iconClasses[index % iconClasses.length]"></i>
            </div>
            <h3>{{ feature?.title }}</h3>
            <p>{{ feature?.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'IncludedBestFeatures',
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      iconClasses: [
        'ri-eye-line',
        'ri-stack-line',
        'ri-leaf-line',
        'ri-secure-payment-line',
        'ri-cloud-line',
        'ri-pie-chart-2-line',
      ],
    };
  },
};
</script>
